package com.rajen.angrejidictionary.presentation.viewmodel

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.rajen.angrejidictionary.analytics.Umami
import com.rajen.angrejidictionary.data.repository.WordRepository
import com.rajen.angrejidictionary.domain.model.WordNotFoundException
import com.rajen.angrejidictionary.presentation.state.WordUiState

class WordViewModel(
    private val repository: WordRepository = WordRepository()
) {

    var uiState by mutableStateOf<WordUiState>(WordUiState.Loading)
        private set

    suspend fun loadWord(term: String? = null) {
        uiState = WordUiState.Loading
        val cleanTerm = term?.trim()?.lowercase()

        if (!cleanTerm.isNullOrBlank()) {
            Umami.trackWordSearch(cleanTerm)
        }

        try {
            val word = if (cleanTerm.isNullOrBlank()) {
                repository.getTodayWord()
            } else {
                repository.getWordByTerm(cleanTerm)
            }
            uiState = WordUiState.Success(word)
        } catch (_: WordNotFoundException) {
            val notFoundTerm = cleanTerm.orEmpty()
            Umami.trackWordNotFound(notFoundTerm)
            uiState = WordUiState.NotFound(notFoundTerm)
        } catch (_: io.ktor.client.plugins.ClientRequestException) {
            if (!cleanTerm.isNullOrBlank()) {
                Umami.trackWordNotFound(cleanTerm)
                uiState = WordUiState.NotFound(cleanTerm)
            } else {
                Umami.trackWordLoadError("word-of-day-unavailable")
                uiState = WordUiState.Error("Unable to load today's word.")
            }
        } catch (_: io.ktor.client.plugins.ServerResponseException) {
            Umami.trackWordLoadError("server-error")
            uiState = WordUiState.Error("Server error. Please try again later.")
        } catch (_: io.ktor.client.network.sockets.SocketTimeoutException) {
            Umami.trackWordLoadError("timeout")
            uiState = WordUiState.Error("Request timed out.")
        } catch (e: Exception) {
            println("❌ WordViewModel error: ${e.message}")
            e.printStackTrace()
            Umami.trackWordLoadError(e.message ?: "unknown")
            uiState = WordUiState.Error("Something went wrong: ${e.message}")
        }
    }
}